'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigateToExistingThread = navigateToExistingThread;

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _loadExistingThread = require('./loadExistingThread');

function navigateToExistingThread(_ref) {
  var threadId = _ref.threadId,
      channel = _ref.channel;

  return function (dispatch) {
    dispatch((0, _loadExistingThread.loadExistingThread)({ threadId: threadId, channel: channel }));

    dispatch((0, _trackInteraction.trackInteraction)('widget-interaction', {
      action: 'view thread'
    }));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/navigation/actions/navigateToExistingThread.js
// module id = 971
// module chunks = 2 3